import * as actionTypes from "../actionTypes";

export const startLoader = () => ({
  type: actionTypes.START_LOADING,
  loading: true,
});
export const stopLoader = () => ({
  type: actionTypes.STOP_LOADING,
  loading: false,
});
